<template>
  <router-link v-if="routerName" :to="{name: routerName, hash: hash, query: query}" class="btn-text" @click="clickHandler">

    <slot></slot>
  </router-link>
  <a v-else-if="href" :href="href" class="btn-text" @click="clickHandler">
    <slot></slot>
  </a>
  <button v-else class="btn-text" @click="clickHandler">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'btn-text',
  props: [ 'routerName', 'href', 'hash', 'query' ],
  methods: {
    clickHandler: function (e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";
  .btn-text {
    &:hover {
      text-decoration: underline;
      color: $orange;
    }
    &.-underline {
      text-decoration: underline;
    }
    &.-next {
      background: url("../../assets/images/icons/arrow-right-gray.svg");
      background-repeat: no-repeat;
      background-size: 8px 14px;
      background-position: right center;
      padding-right: 20px;
    }
    &.-ib {
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/button/BtnText.vue